export default __webpack_public_path__ + "static/automatic-delivery-abe4b559e59a6744bf70d0756634607c.jpg";